import { Room } from '@spike/room-model';
import clsx from 'clsx';
import PetTypeTags from 'components/UI/V3/PetTypeTags';
import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import RoomCoverPhoto from './RoomCoverPhoto';
import styles from './RoomNameCell.module.scss';
import { getRoomAreaLabel } from 'utils/roomEligibility';

interface RoomNameCellProps {
    room: Room;
    className?: string;
}

export const RoomNameCell: FunctionComponent<RoomNameCellProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.left}>
                <RoomCoverPhoto room={props.room} />
            </div>
            <div className={styles.right}>
                <span className={styles.name}>{props.room.name}</span>
                <PetTypeTags petTypes={props.room.petTypes} />
                {isMobile && (
                    <div className={styles.row}>
                        <span className={styles.info}>{getRoomAreaLabel(props.room)}</span>
                        <span className={styles.info}>Qty: {props.room.units.length}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RoomNameCell;
